import { Container } from 'nonaction';
import useText from './Hooks/useText.js';
import useImageAssets from './Hooks/useImageAssets.js';
import usePrintSettings from './Hooks/usePrintSettings.js';
export const TextContainer = Container(useText);
export const ImageAssetsContainer = Container(useImageAssets);
export const PrintSettingsContainer = Container(usePrintSettings);
